import { render, staticRenderFns } from "./CalendarDisplay.vue?vue&type=template&id=d5d3783a&scoped=true"
import script from "./CalendarDisplay.vue?vue&type=script&lang=js"
export * from "./CalendarDisplay.vue?vue&type=script&lang=js"
import style0 from "./CalendarDisplay.vue?vue&type=style&index=0&id=d5d3783a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d3783a",
  null
  
)

export default component.exports